<template>
  <div class="wrap">
    <div class="header-wrap">
      <div class="container">
        <div class="header-group">
          <span class="logo">
            <img src="/image/logo_row01.svg" alt="amis">
          </span>
          <button type="button" class="nav-btn right" @click="$router.back()"><i class="icon-close"></i></button>
        </div>
      </div>
    </div>
    <div class="content-wrap-v3">
      <div class="container">
        <div class="row">
          <div class="confirm-area">
            <div class="confirm-info-visual">
              <i class="bg_symbol_20 mb-30"></i>
              <p class="confirm-subtit">결제가 실패하였습니다.</p>
              <p class="confirm-desc">다시 한번 시도해 주세요.</p>
            </div>
            <div class="confirm-info-list">
              <dl>
                <dt class="text-tit">현재 AMIS</dt>
                <dd class="point-color-black">{{ payBalance | numberWithCommas }}AMIS</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrap">
      <div class="container">
        <div class="row">
          <div class="button-wrap">
            <button class="l_btn btn-black w-100" @click="$router.replace({name:'PaymentInputAmount',params:{paymentQR:paymentQR}})">재결제</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentFail",
  data() {
    return {
      paymentQR: '',
      paymentTime: '',
      payBalance: '0',
    }
  },
  mounted() {
    this.paymentQR = this.$route.params.paymentQR

    let current = new Date()
    let year = current.getFullYear()
    let month = current.getMonth() + 1
    let day = current.getDate()
    let h = current.getHours()
    let m = current.getMinutes()
    let s = current.getSeconds()

    this.paymentTime = year + '.' + month + '.' + day + '.' + h + ':' + m + ':' + s

    this.$get(this.$WALLET_REAPPAY_BALANCE, 'paymentfail_mounted', (result) => {
      this.payBalance = result.data * 1
    }, (result) => {
      this.httpError(result.data)
    })
  }
}
</script>

<style scoped>
.header-group .logo { position: relative; display: inline-block; height: 20px; width: 70px; }
.wrap { position: relative; width: 100%; min-height: 100%; height: 100%; margin: 0 auto; }
</style>
